import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { withStyles, makeStyles, createStyles } from "@material-ui/core/styles";
import {
  Grid,
} from "@material-ui/core";
import { getDashboardRegUsersData } from "actions";
import MUIDataTable from "mui-datatables";

const useStyles = makeStyles((theme) =>
  createStyles({
    volt: {
      paddingTop: theme.spacing(0.5),
      backgroundColor: "#fd5842",
      color: "#fff",
    },
    ampere: {
      paddingTop: theme.spacing(0.3),
      backgroundColor: "#4ba0c1",
      color: "#fff",
    },
    watt: {
      paddingTop: theme.spacing(0.5),
      backgroundColor: "#6eb26e",
      color: "#fff",
    },
    tableHead: {
      height: 48,
      backgroundColor: "#fafafa",
    },
    tableRow: {
      height: 32,
      "&:hover": {
        backgroundColor: theme.palette.action.hover,
      },
    },
    tableRowNone: {
      height: 126,
    },
    tblHead: {
      textAlign: "center",
      fontSize: 14,
      fontWeight: 500,
    },
    tblHeadLeft: {
      textAlign: "left",
      fontSize: 14,
      fontWeight: 500,
    },
    tblDataCenter: {
      textAlign: "center",
    },
    tblDataLeft: {
      textAlign: "left",
    },
    customTitle: {
      fontSize: 16,
      color: "#000",
    },
  })
);

const UsersTable = ({ kpiRegisteredUserData, getDashboardRegUsersData }) => {
  const classes = useStyles();
  const [initialDataCall, setInitialDataCall] = useState(true);

  useEffect(() => {
    if (initialDataCall) {
      getDashboardRegUsersData();
      setInitialDataCall(false);
    }
  }, []);

  const columns = [
    {
      name: "#",
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value) => {
          return <div className={classes.tblDataCenter}>{value}</div>;
        },
      },
    },
    {
      name: "メールアドレス",
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value) => {
          return <div className={classes.tblDataLeft}>{value}</div>;
        },
      },
    },
    {
      name: "事業者",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => {
          return <div className={classes.tblDataLeft}>{value}</div>;
        },
      },
    },
    {
      name: "ステータス",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => {
          return <div className={classes.tblDataCenter}>{value}</div>;
        },
      },
    },
    {
      name: "登録日",
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value) => {
          return <div className={classes.tblDataCenter}>{value}</div>;
        },
      },
    },
  ];
  const options = {
    filterType: "checkbox",
    filter: true,
    pagination: true,
    search: true,
    print: false,
    download: true,
    viewColumns: false,
    downloadOptions: {
      filename: "BIツール登録ユーザー",
      filterOptions: {
        useDisplayedColumnsOnly: true,
        useDisplayedRowsOnly: true,
      },
    },
    selectableRows: "none",
    rowsPerPage: 100,
    textLabels: {
      body: {
        noMatch: "データを取得中です。。",
        toolTip: "",
      },
      toolbar: {
        search: "検索",
        viewColumns: "列の表示",
        downloadCsv: "CSVダウンロード",
        filterTable: "テーブルのフィルター",
      },
      viewColumns: {
        title: "表示する列",
        titleAria: "テーブルの列の表示/非表示",
      },
      pagination: {
        next: "次のページ",
        previous: "前のページ",
        rowsPerPage: "表示件数",
      },
      filter: {
        all: "全て",
        title: "フィルター",
        reset: "リセット",
      },
      selectedRows: {
        text: "レコードを選択",
        delete: "削除",
        deleteAria: "選択したレコードを削除する",
      },
    },
    rowsPerPageOptions: [100, 150, 200],
  };

  return (
    <Grid container spacing={1}>
      <Grid item sm={12}>
        <MUIDataTable
          title={
          <span className={classes.customTitle}>
            {`登録ユーザー数 : ${kpiRegisteredUserData.length != 0 ? kpiRegisteredUserData.length : "-"}`}
          </span>}
          data={kpiRegisteredUserData}
          columns={columns}
          options={options}
        />
      </Grid>
    </Grid>
  );
};

UsersTable.propTypes = {
  classes: PropTypes.object,
};

const mapStateToProps = (state) => ({
  kpiRegisteredUserData: state.kpi.kpiRegisteredUserData,
});

const mapDispatchToProps = (dispatch) => ({
  getDashboardRegUsersData: (param) => dispatch(getDashboardRegUsersData(param)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(null, { withTheme: true })(UsersTable));
